import { gql, TypedDocumentNode } from "@apollo/client";
import { UniversityRosterRowsQuery, UniversityRosterRowsQueryVariables } from "./types";

export const UNIVERSITY_ROSTER_ROWS_QUERY: TypedDocumentNode<
  UniversityRosterRowsQuery,
  UniversityRosterRowsQueryVariables
> = gql`
  query getUniversityRosterRows(
    $universityId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $rosterStatus: String
    $includeErrors: Boolean = true
    $search: String
  ) {
    university(id: $universityId) {
      id
      legacyId
      name
      universityRosterRows(
        first: $first
        after: $after
        last: $last
        before: $before
        rosterStatus: $rosterStatus
        includeErrors: $includeErrors
        search: $search
      ) {
        edges {
          node {
            id
            handicap
            educationLevel
            transferHours
            transferHoursAccepted
            hasErrors
            errorMessages
            validForSubmission
            importWarnings {
              field
              message
              details
            }
            personAttributes
            person {
              id
              firstName
              lastName
              email
              pgaId
              profilePhoto
              dob {
                year
                month
                day
              }
              contactAddress {
                id
                address1
                address2
                city
                state
                postalCode
                countryCode
              }
              phoneNumbers {
                id
                phoneNumber
                phoneType
                phoneFormatted
              }
              playingAbilityTestStatus {
                status
                completed
                expired
                activeSuspension {
                  startDate
                  endDate
                }
              }
            }
            roster {
              id
              status
              createdAt
              university {
                legacyId
                name
              }
              submittedBy {
                id
                name
              }
              finalizedBy {
                id
                name
              }
            }
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
      }
    }
  }
`;

export const FINALIZE_STUDENT_ROSTER_MUTATION = gql`
  mutation FinalizeStudentRoster($rosterId: ID!) {
    finalizeStudentRoster(rosterId: $rosterId) {
      success
      errors {
        field
        base
      }
      cohort {
        id
        name
        createdAt
      }
      studentCount
      message
    }
  }
`;
